export default "__VITE_ASSET__9948f7ea__"